import AdminDashboardSidebarModule from './containers/adminDashboardSidebarModule'

export {default as AdminDashboardSidebarModuleLayout} from './components/adminDashboardSidebarModuleLayout'

export default AdminDashboardSidebarModule
